/**
 * Tree
 * Each node represents a transaction. Branches are changes
 * over time.
 */

'use strict';

exports.__esModule = true;
function Tree() {}

Tree.prototype = {

  focus: null,

  checkout: function checkout(node) {
    if (process.env.NODE_ENV !== 'production' && typeof node === 'undefined') {
      throw new TypeError('Tree was asked to focus on a Node, but instead got ' + node);
    }

    this.focus = node || this.focus;
  },

  back: function back() {
    if (this.focus) {
      this.checkout(this.focus.parent);
    }
  },

  forward: function forward() {
    if (this.focus) {
      this.checkout(this.focus.next());
    }
  },

  append: function append(item) {
    this.focus = new Node(item, this.focus);
    return this.focus;
  },

  prune: function prune(shouldRemove, scope) {
    var node = this.root();

    while (node && shouldRemove.call(scope, node.value)) {
      node.dispose();
      node = node.next();
    }

    // If we reach the end (there is no next node), it means
    // we've completely wiped away the tree, so nullify focus
    // to mark a completely empty tree.
    if (!node) {
      this.focus = null;
    }
  },

  branch: function branch() {
    var node = this.focus;
    var items = [];

    while (node) {
      items.push(node.value);
      node = node.parent;
    }

    return items.reverse();
  },

  root: function root() {
    var node = this.focus;

    while (node && node.parent) {
      node = node.parent;
    }

    return node;
  },

  size: function size() {
    var count = 0;
    var node = this.focus;

    while (node) {
      node = node.parent;
      count = count + 1;
    }

    return count;
  }

};

function Node(value, parent) {
  this.children = [];
  this.parent = parent;
  this.value = value;

  if (parent) {
    parent.children.unshift(this);
  }
}

Node.prototype = {

  next: function next() {
    return this.children.length ? this.children[0] : null;
  },

  dispose: function dispose() {
    for (var i = 0, size = this.children.length; i < size; i++) {
      this.children[i].parent = null;
    }
  }

};

exports['default'] = Tree;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,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




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/Tree.js
 ** module id = 193
 ** module chunks = 0
 **/